import { createAsyncThunk } from '@reduxjs/toolkit';
import chatService from '../../../api/services/chat';

export const getAllChatRooms = createAsyncThunk('chat/getAllChatRooms', async ({ page, search }) => {
  return await chatService.getAllChatRooms(page, search);
});

export const getChatRoom = createAsyncThunk('chat/getChatRoom', async ({ id, page }) => {
  return await chatService.getChatRoom(id, page);
});

export const postMediaMessage = createAsyncThunk('chat/postMediaMessage', async requestData => {
  const { message, type, chatRoomId } = requestData;

  let formData = new FormData();

  if (message !== null) {
    formData.append('type', type);
    formData.append('file', message);
  }

  return await chatService.sendMediaInChat(formData, chatRoomId);
});
